export default "__VITE_ASSET__Dgg_29N9__"